import { useEffect } from 'react';

/**
 * Hält die Seite hinter einem nicht-modalen Fenster still: `inert` am App-Knoten, kein Scrollen
 * dahinter. Das ersetzt die Fokusfalle des modalen Radix-Fensters dort, wo sie schadet — die
 * Bankbestätigung (3-D Secure) legt Stripe als eigenes Fenster an den Body, und eine Fokusfalle
 * holte jeden Tastendruck daraus zurück; gesperrte Zeigerereignisse machten es unklickbar.
 */
export function useInertBackground(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const root = document.getElementById('root');
    const previousOverflow = document.body.style.overflow;
    root?.setAttribute('inert', '');
    document.body.style.overflow = 'hidden';
    return () => {
      root?.removeAttribute('inert');
      document.body.style.overflow = previousOverflow;
    };
  }, [active]);
}
